export default __webpack_public_path__ + "static/media/include_5_male@3x.5a681c24.jpg";